module.exports = __webpack_public_path__ + "static/media/3.09efd0d8.png";